import React, { useState, useEffect } from "react";
import { isAuthenticated } from "../../auth";
import { Redirect, Link } from "react-router-dom";
import Swal from "sweetalert2";

const DeleteCategory = (props) => {
  const remove = (categoryId, userId, token) => {
    return fetch(
      `${process.env.REACT_APP_API_URL}/category/${categoryId}/${userId}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    ).then((data) => {
      Swal.fire("Deleted successfully");
    });
  };

  const Delete = () => {
    const token = isAuthenticated().token;
    const categoryId = props.categoryId;
    const userId = isAuthenticated().user._id;
    remove(categoryId, userId, token);
  };

  const DeleteCategory = () => {
    let answer = window.confirm("Are you sure, you want to delete this blog");
    if (answer) {
      Delete();
    }
  };

  return (
    <div>
      <div className="mb-2 ml-4 mt-2">
        <Link
          to="/admin/dashboard"
          className="btn btn-danger"
          style={{ borderRadius: "0" }}
          onClick={DeleteCategory}
        >
          Delete
        </Link>
      </div>
    </div>
  );
};

export default DeleteCategory;
